import { useMediaQuery } from '@tapresearch/ui/hooks';

export const useBreakpoint = () => {
  const [isXs, isSm, isMd, isLg, isXl, isLandscape] = useMediaQuery([
    '(max-width: 576px)',
    '(max-width: 768px)',
    '(max-width: 992px)',
    '(max-width: 1200px)',
    '(max-width: 10000px)',
    '(min-aspect-ratio: 13/9)'
  ]);
  return { isXs, isSm, isMd, isLg, isXl, isLandscape };
};